export const FEED_LIMIT = 20;
export const COMMENTS_LIMIT = 20;

export const FEED_TABS = {
  TRENDING: 'trending',
  NEW: 'new',
};

export const DEFAULT_FEED_TAB = FEED_TABS.TRENDING;

export const FEED_PHASE = {
  TRENDING: 'TRENDING',
  RECENT: 'RECENT',
};

export const SHARE_PLATFORM_MAP = {
  copy_link: 'COPY_LINK',
  telegram: 'TELEGRAM',

  other: 'OTHER',
  repost: 'REPOST',
};
